import { get } from '../services/AddressLookupService'

export const state = {
  postcodeInput: '',
  addresses: [
    {
      addressId: '',
      addressText: ''
    }
  ],
  address: {
    id: '',
    company: '',
    line1: '',
    line2: '',
    line3: '',
    line4: '',
    line5: '',
    city: '',
    county: '',
    postcode: '',
    country: '',
    buildingNumber: '',
    buildingName: '',
    subBuilding: '',
    street: '',
    secondaryStreet: '',
    district: '',
    province: ''
  },
  status: 'ready'
}

const POSTCODE_REGEXP = new RegExp('.*,\\s(.*)$')

export const mutations = {
  LOAD_ADDRESSES_REQUEST: state => {
    state.status = 'loading'
  },
  LOAD_ADDRESSES_SUCCESS: (state, addresses) => {
    state.addresses = []
    addresses.forEach(address => {
      state.addresses.push({
        addressId: address.Id,
        addressText: `${address.Text}, ${address.Description}`,
        addressPostcode: address.Description.match(POSTCODE_REGEXP)[1]
      })
    })
    state.status = 'success'
  },
  LOAD_ADDRESSES_ERROR: state => {
    state.status = 'error'
  },
  LOAD_ADDRESSES_READY: state => {
    state.status = 'ready'
  },
  UPDATE_POSTCODE_INPUT: (state, value) => {
    state.postcodeInput = value
  },
  LOAD_ADDRESS_SUCCESS: (state, address) => {
    const newAddress = {
      id: address.Id,
      company: address.Company,
      line1: address.Line1,
      line2: address.Line2,
      line3: address.Line3,
      line4: address.Line4,
      line5: address.Line5,
      city: address.City,
      county: address.ProvinceName,
      postcode: address.PostalCode,
      country: address.CountryName,
      buildingNumber: address.BuildingNumber,
      buildingName: address.BuildingName,
      subBuilding: address.SubBuilding,
      street: address.Street,
      secondaryStreet: address.SecondaryStreet,
      district: address.District,
      province: address.Province
    }

    state.address = newAddress
    state.status = 'success'
  }
}

export const actions = {
  actionLoadAddresses ({ commit }, query) {
    commit('LOAD_ADDRESSES_REQUEST')
    return get(query, 'search')
      .then(apiResponse => {
        if (apiResponse.status === 200 && apiResponse.data.Items.length > 0) {
          commit('LOAD_ADDRESSES_SUCCESS', apiResponse.data.Items)
        } else {
          throw apiResponse
        }
      })
      .catch(error => {
        commit('LOAD_ADDRESSES_ERROR')
        throw error
      })
  },
  actionLoadAddress ({ commit }, addressId) {
    commit('LOAD_ADDRESSES_REQUEST')
    return get(addressId, 'fetch')
      .then(apiResponse => {
        if (apiResponse.status === 200) {
          commit('LOAD_ADDRESS_SUCCESS', apiResponse.data.Items[0])
        } else {
          throw apiResponse
        }
      })
      .catch(error => {
        commit('LOAD_ADDRESSES_ERROR')
        throw error
      })
  }
}

export const getters = {
  getPostcodeInput: (state) => state.postcodeInput
}
